import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import LoginPage from './pages/LoginPage';
import ProgressTracker from './pages/ProgressTracker';
import ProfilePage from './pages/ProfilePage';
import RegisterPage from './pages/RegisterPage';
import ModuleIndex from './pages/ModuleIndex';
import CourseList from './pages/CourseList';
import LessonList from './pages/LessonList';
import LessonDetail from './pages/LessonDetail';
import EditorLauncher from './pages/EditorLauncher';
import CourseQuiz from './pages/CourseQuiz';
import QuizResults from './pages/QuizResults';
import CompletionPage from './pages/CompletionPage';
import './style.css';

function App() {
  return (
    <Router>
      <Layout>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/" element={<ModuleIndex />} />
          <Route path="/module/:moduleId" element={<CourseList />} />
          <Route path="/module/:moduleId/complete" element={<CompletionPage />} />
          <Route path="/module/:moduleId/course/:courseId" element={<LessonList />} />
          <Route path="/module/:moduleId/course/:courseId/quiz" element={<CourseQuiz />} />
          <Route path="/module/:moduleId/course/:courseId/quiz/results" element={<QuizResults />} />
          <Route path="/module/:moduleId/course/:courseId/lesson/:lessonId" element={<LessonDetail />} />
          <Route path="/editor" element={<EditorLauncher />} />
          <Route path="/progress" element={<ProgressTracker />} />
          <Route path="/profile" element={<ProfilePage />} />
        </Routes>
      </Layout>
    </Router>
  );
}

export default App;




